import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.map.js";
import { filterByType } from "../../../data";
import { parse } from "../../../utils/parse";
import { CommissionTransaction } from "../../../types";
import { useApplicationPageAggregatedData } from "./aggregatedData";

// Note: some of the attributes of the commission transactions can theoretically be null or undefined
// because these values are allowed by the DB. It is not expected that this will ever be true, but in
// that case we will show a zod error within the ErrorBoundary of the CommissionTab.
// See discussion: https://applyboard.atlassian.net/browse/DEM-794?focusedCommentId=1172802
// and Nishant's approval: https://applyboard.atlassian.net/browse/DEM-794?focusedCommentId=1172822
export var CommissionTransactionsWithSingleCurrency = CommissionTransaction.array().refine(function (transactions) {
  var currencies = new Set(transactions === null || transactions === void 0 ? void 0 : transactions.map(function (transaction) {
    return transaction.currency;
  }));
  return currencies.size <= 1;
}, {
  message: 'Multiple currencies found in application commission transactions'
});
export function useCommissionTransactions() {
  var _useApplicationPageAg = useApplicationPageAggregatedData({
      select: function select(data) {
        return parse(CommissionTransactionsWithSingleCurrency, filterByType(data.included, 'application_transaction').map(function (commissionTransaction) {
          return commissionTransaction.attributes;
        }));
      }
    }),
    data = _useApplicationPageAg.data;
  return {
    commissionTransactions: data || []
  };
}